export class MedicalFeeControlSearchItemExport {
    public Fecha: Date;
    public FechaEjecucion?: Date;
    public Paciente: string;
    public Protocolo: string;
    public Practica: string;
    public Importe?: number;
    public Accion: string;
    public Medico: string;
    public Estado: string;
    public Centro: string;
    public Entidad: string;
    public Servicio: string;
    public Cantidad: number;
}